"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconMinus', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M12.9399 9H3.06007C2.47461 9 2 8.55228 2 8C2 7.44772 2.47461 7 3.06007 7H12.9399C13.5254 7 14 7.44772 14 8C14 8.55228 13.5254 9 12.9399 9Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M4 11C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H4Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M4.79998 13.2C4.13723 13.2 3.59998 12.6627 3.59998 12C3.59998 11.3373 4.13723 10.8 4.79998 10.8H19.2C19.8627 10.8 20.4 11.3373 20.4 12C20.4 12.6627 19.8627 13.2 19.2 13.2H4.79998Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M6.39999 14.4C5.51633 14.4 4.79999 15.1163 4.79999 16C4.79999 16.8837 5.51633 17.6 6.39999 17.6H25.6C26.4836 17.6 27.2 16.8837 27.2 16C27.2 15.1163 26.4836 14.4 25.6 14.4H6.39999Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;